import styled from 'styled-components';
import { breakpoints } from 'styles/breakpoints';
import { Box } from '@mui/material';

export const StyledWhispersOfferSection = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 14%;
  min-width: 80px;
  width: 100%;
  padding: 0 1px;
  box-sizing: border-box;
  flex-direction: column;
  transform: translateX(-50%);
  left: 50%;
` as any;

export const StyledQuantitySection = styled(Box)`
  display: flex;
  align-items: center;

  img {
    object-fit: contain;
    height: 14px;
    width: 14px;
  }

  .quantity {
    color: #000;
    font-weight: 700;
    font-size: 14px;
    line-height: normal;
    margin: 0;

    @media (width < ${breakpoints.mobileS}) {
      font-size: 16px;
    }
  }

  .stroked-quantity {
    color: #959394;
    position: relative;
    font-size: 8px;
    font-style: normal;
    font-weight: 500;
    text-decoration-line: line-through;
  }

  @media (min-width: 425px) {
    img {
      height: 14px;
      width: 14px;
    }

    .text {
      max-width: calc(100% - 95px);
    }
  }
`;
